import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import type { PageFunctionType } from '@shared/core/analytics/telemetry/types';

const category = 'registry';
const pagePrefix = 'admin';

interface RegistryOverviewTelemetryContext {
  eventId: string;
  page: string;
  layoutVariant?: string;
  giftCount?: number | null;
}

type RegistryOverviewInteractionArgs = {
  component: string;
  method?: string;
  label?: string;
  [other: string]: string | undefined | number | boolean;
};

type PagesForTelemetry = {
  addGiftAndOverview: 'addGiftAndOverview';
};

const pageTracking: { [key in keyof PagesForTelemetry]: PageFunctionType } = {
  addGiftAndOverview: () => ({
    category: 'registry',
    pagePrefix: 'admin',
    page: 'AddGiftAndOverview',
    action: 'ViewAddGiftAndOverview',
  }),
};

export const registryOverviewTelemetry = createTelemetryObject({
  actions: {
    registryOverviewInteraction: (args: RegistryOverviewInteractionArgs) => ({
      action: 'RegistryOverviewInteraction',
      actionType: undefined,
      pagePrefix,
      category,
      extraInfo: args,
    }),
    adminRegistryQuickLinkInteraction: (args: RegistryOverviewInteractionArgs) => ({
      action: 'AdminRegistryQuickLinkInteraction',
      actionType: undefined,
      pagePrefix,
      category,
      extraInfo: args,
    }),
    registryManageTabClicked: (label: string) => ({
      action: 'RegistryManageTab',
      actionType: 'click',
      pagePrefix,
      category,
      extraInfo: {
        label,
      },
    }),
  },
  pages: pageTracking,
});

const { TelemetryProvider, useTelemetry } = createTelemetry(registryOverviewTelemetry, { eventId: '' } as RegistryOverviewTelemetryContext);

export { TelemetryProvider, useTelemetry as useRegistryOverviewTelemetry };
